import { useMemo } from "react";
import { useAuth } from "../contexts/AuthProvider";
import { useNationBuilderToken } from "../contexts/NationBuilderTokenProvider";
import ApiClient from "../api/ApiClient";

export const useApiClient = () => {
  const { accessToken, handleError } = useAuth();
  const { handleError: handleNationBuilderTokenError } =
    useNationBuilderToken();

  const apiClient = useMemo(() => {
    return new ApiClient(undefined, {
      getAccessToken: () => accessToken,
      handleAuthError: handleError,
      handleNationBuilderTokenError: handleNationBuilderTokenError,
    });
  }, [accessToken, handleError]);

  return apiClient;
};
